import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

export const Template = () => {
  const { businessID, siteID } = useParams();

  return (
    <Navigate
      to={`/dashboard/projects/${businessID}/templates/${siteID}/pages`}
      replace
    />
  );
};
